export const createPagination = (total: number, pageSize: number, page: number) =>
  total >= pageSize
    ? {
        total,
        current: page,
        pageSize: pageSize,
        showSizeChanger: false,
        showQuickJumper: false,
        itemRender: (_, type, element) => (type === "prev" || type === "next" ? element : ""),
      }
    : false;
